import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getAllCourse = para => requestActionMaker({ cons: cons.GET_ALL_COURSE, api: apis.getAllCourse, ...para });
export const getCourse = para => requestActionMaker({ cons: cons.GET_COURSE, api: apis.getCourse, ...para });